import { render, staticRenderFns } from "./DocumentBySupplierDialog.vue?vue&type=template&id=31fb2afb&scoped=true&"
import script from "./DocumentBySupplierDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentBySupplierDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentBySupplierDialog.vue?vue&type=style&index=0&id=31fb2afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb2afb",
  null
  
)

export default component.exports